let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l541I")).then(() => parcelRequire('cAlmw'));